module.exports = "/build/web/svg/social/small/linkedin.e599860ada54ba68d232fcb6a23012e9.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/linkedin.svg
// module id = 194
// module chunks = 24